import React from "react";
import { Header } from "./header/Header";
import { Footer } from "./footer/Footer";
import { PopUp } from "./popup/PopUp";

// component styles
import "./index.scss";
import { WebsCta } from "./webs-cta/WebsCta";

export const Layout: React.FC<LayoutProps> = ({
  footerRedirections = true,
  headerTransition = true,
  header = true,
  footer = true,
  children,
}) => {
  return (
    <div id="page-wrapper" className="page-wrapper">
      {header ? <Header transition={headerTransition} /> : <></>}
      {children}
      {footer ? (
        <>
          <Footer />
          {footerRedirections ? <WebsCta /> : <></>}
        </>
      ) : (
        <></>
      )}
      <PopUp />
    </div>
  );
};
